/**
 * @param {SocialConnectConnectorAbstract} connector
 */
var SocialConnectButton = function(connector) {

    connector.onInitAfter(function() {
        $j(document).on('click', '[data-js=social-connect-button][data-social-connect-type=' + $j.escapeSelector(connector.getType()) + ']', function() {
            let $button = $j(this);

            connector.connect().done(function() {
                if ($button.attr('data-social-connect-redirect-url')) {
                    location.href = $button.attr('data-social-connect-redirect-url');
                }
            });
        });

        connector.onClientConnectFailAfter(function() {
            alert(Translator.translate('Something went wrong, try again...'));
        }, DeferredEvents.PRIORITY_HIGHEST);

        connector.onServerConnectFailAfter(function() {
            alert(Translator.translate('Something went wrong, try again...'));
        }, DeferredEvents.PRIORITY_HIGHEST);
    });
};

new SocialConnectButton(window.socialConnectConnectorFacebook);
new SocialConnectButton(window.socialConnectConnectorGoogle);
